<template>
    <Form
        :settings="settings"
        :errors="errors"
        @form-submitted="submitData"
    />
</template>

<script setup>
import Form from '~@/Components/Settings/NetLedgerSettings/Form'
import { route } from '~@/Composables/route'

defineProps({
    settings: {
        type: Object,
        default () {
            return {}
        }
    },
    errors: {
        type: Object,
        default () {
            return {}
        }
    }
})

const submitData = (form) => {
    form.post(route('settings.netledger-settings.store'))
}
</script>
